import { gql } from '@apollo/client';

const Fragments = {
  user: gql`
    fragment user on UserModel {
      id
      name
      personId
      personName
      partnerId
      partnerName
      remark
      inactive
      passwordChangedByAdmin
      failedLoginAttempts
      lastLoginDate
      passwordChangeDate
    }
  `
};

export default Fragments;
